import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserBalanceDto } from 'src/app/interfaces/user-balance.dto';
import { SharedModule } from '../../shared/shared.module';

declare const bootstrap: any; // Bootstrap 5 modal API

@Component({
  selector: 'app-balance-list',
  templateUrl: 'balance-list.component.html',
  styleUrls: ['balance-list.component.css'],
  standalone: true,
  imports: [CommonModule, SharedModule]
})
export class BalanceListComponent implements OnInit {
  @Input() balances: UserBalanceDto[] = [];
  @Output() investmentsChange = new EventEmitter<UserBalanceDto[]>();
  @Input() isLoading: boolean = false;
  @Input() resume?: {page: number, range: number, total: number} = undefined;

  constructor() {}

  ngOnInit() {
    //
  }
}
